import React from 'react';
import { FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';

import { Question } from '../../types/DataTypes';
import { containsAnswer } from '../../utils/assessmentUtils';
import { AssessmentResultAnswer, SubAnswer } from '../../types';

const handleCheckboxChangeHelper = (
  event: React.ChangeEvent<HTMLInputElement>,
  questionType: Question,
  answer: AssessmentResultAnswer,
  answerUidToAnswerMap: { [key: string]: SubAnswer },
  onAnswerChange: (questionType: Question, updatedAnswer: AssessmentResultAnswer) => void,
): void => {
  const answerUid = event.target.name;
  const updatedAnswer = { ...answer };
  // Add answer to selection
  if (event.target.checked) {
    updatedAnswer.answers.push(
      answerUidToAnswerMap[event.target.name],
    );
  } else {
  // Remove answer from selection
    updatedAnswer.answers = updatedAnswer.answers.filter((item) => item.uid !== answerUid);
  }

  onAnswerChange(questionType, updatedAnswer);
};

type Props = {
  question: Question;
  answer: AssessmentResultAnswer;
  onAnswerChange: (question: Question, updatedAnswer: AssessmentResultAnswer) => void;
  answerUidToAnswerMap: { [key: string]: SubAnswer };
  disabled?: boolean;
};

const MultipleSelect: React.FC<Props> = (props: Props) => {
  const {
    question, onAnswerChange, answer, disabled, answerUidToAnswerMap,
  } = props;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleCheckboxChangeHelper(event, question, answer, answerUidToAnswerMap, onAnswerChange);
  };

  return (question.answers && (
    <FormGroup>
      {
        question.answers?.map((possibleAnswer) => (
          <FormControlLabel
            key={possibleAnswer?.uid}
            control={(
              <Checkbox
                name={possibleAnswer?.uid}
                onChange={handleCheckboxChange}
                checked={answer && containsAnswer(answer.answers, possibleAnswer)}
                disabled={disabled}
              />
            )}
            label={possibleAnswer?.text}
          />
        ))
      }
    </FormGroup>
  ));
};

export default MultipleSelect;
